<template>
  <div class="as-employee-video-checkpoint-instructions">
    <InstructionsLanguagePicker
      :model-value="selectedLanguage"
      :items="languages"
      :isforce-readonly="true"
      :is-show-defaut-value="true"
      @update:model-value="handleLanguageChange"
      @item-language-selected="handleLanguageSelected"
    />
    <MicrolearningViewEdit
      :video="video"
      :error="error"
      :summary="summary"
      :steps="steps"
      :editable="true"
      :max-steps-height="'400px'"
      :compact-steps-layout="false"
    />
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import InstructionsLanguagePicker from "@components/InstructionsLanguagePicker/InstructionsLanguagePicker.vue";
import MicrolearningViewEdit from "@components/MicrolearningViewEdit/MicrolearningViewEdit.vue";

const props = defineProps({
  video: {
    type: String,
    required: true,
  },
  error: {
    type: String,
    default: null,
  },
  summary: {
    type: Object,
    default: null,
  },
  steps: {
    type: Array,
    default: () => [],
  },
  selectedLanguage: {
    type: Object,
    default: null,
  },
  languages: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits([
  "update:selectedLanguage",
  "language-selected",
]);

const handleLanguageChange = (language) => {
  emit("update:selectedLanguage", language);
};

const handleLanguageSelected = (language) => {
  emit("language-selected", language);
};
</script>

<style scoped>
.as-employee-video-checkpoint-instructions {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 200px;
  position: relative;
}

/* Language picker wrapper - ensure it's above video and dropdown can escape */
.as-employee-video-checkpoint-instructions :deep(.instructions-language-picker) {
  margin-left: 0px;
  margin-bottom: 20px;
  position: relative;
  z-index: 100;
}

/* Ensure dropdown menu appears above video and all other content */
.as-employee-video-checkpoint-instructions :deep(.instructions-language-picker .list-picker-container) {
  z-index: 1000 !important;
}

.as-employee-video-checkpoint-instructions :deep(.instructions-language-picker .v-menu__content) {
  z-index: 1000 !important;
}

/* Ensure video container has lower z-index */
.as-employee-video-checkpoint-instructions :deep(.microlearning-view-edit) {
  position: relative;
  z-index: 1;
}

.as-employee-video-checkpoint-instructions :deep(.microlearning-view-edit__video-container),
.as-employee-video-checkpoint-instructions :deep(.microlearning-view-edit__video-wrapper) {
  position: relative;
  z-index: 1;
}

/* Ensure video element can play and is interactive */
.as-employee-video-checkpoint-instructions :deep(.microlearning-view-edit__video) {
  pointer-events: auto;
}

.as-employee-video-checkpoint-instructions :deep(.microlearning-view-edit__iframe-container) {
  position: relative;
  z-index: 1;
}
</style>

